module.exports = __webpack_public_path__ + "static/media/my_bag.cc386f55.svg";